import React from "react";
import "./petdetails.styles.scss";
import CustomButton from "../../components/custom-button/custom-button.component";
import { connect } from "react-redux";
import logo from "../../assets/logo_4.png";
import { Link } from "react-router-dom";
import MyGallery from "../../components/gallery/gallery.component";
import { getPetInfo } from "../../firebase/firebase.utils";

class PetDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      microchip: "",
      petName: "",
      owner: "",
      petType: "",
      sex: "",
      DOB: "",
      breed: "",
      color: "",
      motherID: "",
      fatherID: "",
      registrationID: "",
      photos: [],
      isEdit: false,
    };
    this.handlePetChange = this.handlePetChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      ...this.props.location.state.referrer,
      microchip: this.props.location.state.microchip,
    });
  }
  handlePetChange(event) {
    getPetInfo(event).then((data) => {
      this.setState({
        microchip: event,
        ...data,
      });
    });
  }

  render() {
    return (
      <div className="petDetail">
        <Link className="logo-container" to="/">
          <img className="logo"  src={logo} alt="logo"/>
        </Link>
        <div className="content">
          <div className="gallery">
            <MyGallery photos={this.state.photos}/>
          </div>
          <div className="petInfo">
            <section>
              <h4>Mã đăng kí: </h4>
              {this.state.registrationID}
            </section>
            <hr></hr>
            <section>
              <h4>Tên thú nuôi: </h4>
              {this.state.petName}
            </section>
            <hr></hr>
            <section>
              <h4>Tên chủ:</h4> {this.state.owner}
            </section>
            <hr></hr>
            <section>
              <h4>Giới tính:</h4> {this.state.sex}
            </section>
            <hr></hr>
            <section>
              <h4>Màu sắc:</h4> {this.state.color}
            </section>
            <hr></hr>
            <section>
              <h4>Chủng loại:</h4> {this.state.breed}
            </section>
            <hr></hr>
            <section>
              <h4>Chip thú nuôi cha: </h4>
              <span
                className="spanLink"
                onClick={this.handlePetChange.bind(this, this.state.fatherID)}
              >
                {this.state.fatherID}
              </span>
            </section>
            <hr></hr>
            <section>
              <h4>Chip thú nuôi mẹ: </h4>
              <span
                className="spanLink"
                onClick={this.handlePetChange.bind(this, this.state.motherID)}
              >
                {this.state.motherID}
              </span>
            </section>

            <br />
            {this.props.currentUser ? (
              <div>
                <Link
                  to={{
                    pathname: "/edit",
                    state: {
                      data: this.state,
                      microchip: this.state.microchip,
                    },
                  }}
                >
                  <CustomButton type="submit">Cập nhật</CustomButton>
                </Link>
                <hr></hr>
                <Link to="/">
                  <CustomButton type="submit">
                    Tra cứu thú cưng khác
                  </CustomButton>
                </Link>
              </div>
            ) : (
              <Link to="/">
                <CustomButton type="submit">Tra cứu mới</CustomButton>
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  currentUser: user.currentUser,
});

export default connect(mapStateToProps)(PetDetails);
